import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { Localization } from "@ea/shared_types/types";
import { moduleActions } from "./localization.actions";

const initialState = {
  ...getDataReducerInitialState<Localization>(),
};

export type LocalizationReducer = typeof initialState;

const dataReducer = createDataReducer<Localization>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
